import { forwardRef } from "react";

// Brand button — three variants:
//   primary        = filled #FF9F1C / #0A0A0A text (hover inverts to canvas/accent)
//   secondaryDark  = 1px #FFF outline (for use on dark surfaces)
//   secondaryLight = 1px #0A0A0A outline (for use on white surfaces)
//   ghost          = link-style, no border
const base =
  "inline-flex items-center justify-center gap-2 font-sans text-[13px] font-bold tracking-[0.02em] uppercase h-14 px-7 " +
  "transition-colors duration-200 ease-out cursor-pointer select-none " +
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#FF9F1C] focus-visible:ring-offset-transparent";

const variants = {
  primary:
    "bg-[#FF9F1C] text-[#0A0A0A] border border-[#FF9F1C] hover:bg-[#0A0A0A] hover:text-[#FF9F1C]",
  secondaryDark:
    "bg-transparent text-white border border-white hover:bg-white hover:text-[#0A0A0A]",
  secondaryLight:
    "bg-transparent text-[#0A0A0A] border border-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white",
  ghost:
    "bg-transparent text-[#FF9F1C] hover:text-[#0A0A0A] border-b border-transparent hover:border-[#0A0A0A] h-auto px-0",
};

const Button = forwardRef(function Button(
  { as: Tag = "button", variant = "primary", size = "md", className = "", children, ...rest },
  ref,
) {
  const v = variants[variant] || variants.primary;
  const sizeCls = size === "sm" ? "h-10 px-4 text-[12px]" : "";
  return (
    <Tag ref={ref} className={[base, v, sizeCls, className].join(" ")} {...rest}>
      {children}
    </Tag>
  );
});

export default Button;
